/** @jsxImportSource @emotion/react */
import { Header } from '@quickbit/backoffice-core-frontend';
import {
  Button,
  Card,
  Icon,
  Loader,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { useNavigate, useParams } from 'react-router-dom';
import { useAsyncFn, useMount } from 'react-use';
import { TransactionItem, ManualReviewButtons } from 'components/Transactions';
import {
  getTransactionDetails,
  Transaction,
} from 'components/Transactions/api';

export const TransactionDetails = () => {
  const { spacing, palette } = useTheme();
  const navigate = useNavigate();

  const { transactionId } = useParams();
  if (!transactionId) {
    throw Error('Missing transactionId param');
  }

  const [{ value: transaction, loading }, getTransaction] =
    useAsyncFn(async () => {
      return getTransactionDetails(transactionId);
    }, [transactionId]);

  useMount(() => {
    void getTransaction();
  });

  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <Header>
        <div
          css={{
            display: 'grid',
            gridTemplateColumns: '1fr auto auto',
            gap: spacing.xxs,
            alignItems: 'center',
          }}
        >
          <div
            css={{ display: 'flex', gap: spacing.xxxs, alignItems: 'center' }}
          >
            <div
              css={{
                cursor: 'pointer',
                ':hover': {
                  textDecoration: 'underline',
                  textDecorationColor: palette.grey.x300,
                },
              }}
              onClick={() => navigate('/transactions')}
            >
              <Typography variant="subtitle" color={palette.grey.x300}>
                Transactions
              </Typography>
            </div>
            <div
              css={{
                transform: 'rotate(180deg)',
                svg: {
                  fill: 'none',
                  stroke: palette.grey.x300,
                },
              }}
            >
              <Icon name="chevron" />
            </div>
            <Typography variant="subtitle">{transactionId}</Typography>
          </div>
        </div>
      </Header>
      <Card>
        <div>
          {transaction && transaction.status === 'MANUAL_REVIEW' && (
            <ManualReviewButtons
              transactionId={transactionId}
              onApprove={getTransaction}
              onReject={getTransaction}
            />
          )}
          <div css={{ display: 'grid', gap: spacing.xxs }}>
            {transaction &&
              Object.entries(transaction)
                .sort(([aK], [bK]) =>
                  aK === 'userId' ? -1 : bK === 'userId' ? 1 : 0
                )
                .map(([k, v]) =>
                  k === 'userId' ? (
                    <Button
                      variant="text"
                      key={k}
                      text={`User: ${v}`}
                      onClick={() =>
                        navigate(
                          `/users/${
                            transaction.amount.currencyCode === 'ALGO' // ALGO_TODO: Fix this if we no longer can assume ALGO === processing
                              ? 'processing'
                              : 'app'
                          }/${v}`
                        )
                      }
                    />
                  ) : (
                    <TransactionItem
                      key={k}
                      name={k as keyof Transaction}
                      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                      value={v}
                    />
                  )
                )}
          </div>
        </div>
      </Card>
    </>
  );
};
